import React from 'react'
import { NavLink } from 'react-router-dom'
import ReportIcon from './icon/Report'
import { menu } from './listMenu'

const active = 'p-2 bg-pink-100 cursor-auto font-bold text-gray-500 text-pink-600'
const notActive = 'p-2 hover:bg-pink-100 cursor-auto font-bold text-gray-500 hover:text-pink-600'



function Sidebar({status}) {
  return (
    <div
    className={` ${
     
      status?" transition-all min-h-screen ease-out duration-500 flex flex-col bg-gray-50 justify-between w-64 py-4 px-2":"transition-all ease-in duration-500 flex flex-col bg-gray-50 justify-between w-0"
        //  "flex flex-col bg-gray-50 h-screen justify-between w-64 py-4 px-2 transition-all ease-in-out duration-500"
         
    }`}
  >
     <div className="flex flex-col items-center justify-between text-gray-600 text-3xl pb-1 ">
      <div className="pb-40 pb-8">
        <b>TSPtkU</b> 
      </div>
      <span className="h-1 bg-slate-300 rounded w-full "></span>
    </div>
    <div className="flex flex-col  flex-auto">
      {menu.map((d,i)=>(
        <NavLink to={d.link}  className={({isActive})=> isActive ? active : notActive} key={i}>
          <div className="flex flex-row space-x-3">
            {d.icon}
            <h4>
              {d.judul}
            </h4>
          </div>
        </NavLink>
      ))}
      
    </div>
  </div>
  )
}

export default Sidebar